import {
  Dialog,
  Typography,
  Grid,
  Button,
  Stack,
  IconButton,
  Box,
} from '@mui/material';

import {
  useGetAuthenticationQuery,
  useGetAuthTokenQuery,
  useDeleteAgentMutation,
} from '../../services/ADapi';

import CloseIcon from '@mui/icons-material/Close';
import Icon from '../Icon';

const DeleteAgentModal = ({ uid, agentName, onClose }) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const [deleteAgent, { isLoading }] = useDeleteAgentMutation();
  const {
    data: { access },
  } = useGetAuthTokenQuery();

  const deleteAgentModal = async () => {
    try {
      await deleteAgent({ user_id, uid, token: access });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog open={true} className="MuiDialog-container" onClose={onClose}>
      <Stack sx={{ gap: 3 }}>
        <Grid container justifyContent="space-between" alignItems="start">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: 'rgba(224, 141, 141, 0.20)',
            }}
          >
            <Icon id="delete" color="warning" />
          </Box>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Typography variant="body1" sx={{ lineHeight: '20px' }}>
          Are you sure you want to delete this agent
          <br /> {agentName}?
        </Typography>
        <Grid container spacing={3} sx={{ pt: 2 }}>
          <Grid item xs={12} md={6}>
            <Button variant="outlined" onClick={onClose} fullWidth>
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="contained"
              type="submit"
              onClick={deleteAgentModal}
              disabled={isLoading}
              fullWidth
            >
              Delete
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Dialog>
  );
};

export default DeleteAgentModal;
